/**
 * InstructionSteps Component - Step-by-Step Instruction List
 *
 * Displays a list of instructions with icons in a clean, inline format.
 * Used in authentication and onboarding flows.
 *
 * USAGE:
 * <InstructionSteps>
 *   <InstructionSteps.Step icon={<SpriteIcon name="inbox" size={15} />}>
 *     Open your inbox and look for the email
 *   </InstructionSteps.Step>
 *   <InstructionSteps.Step icon={<SpriteIcon name="link" size={15} />}>
 *     Tap the secure link to access your account
 *   </InstructionSteps.Step>
 * </InstructionSteps>
 */

import React from 'react';
import '../../theme-components/51-email-sent.css';

export interface InstructionStepsProps {
  children: React.ReactNode;
  className?: string;
}

export interface InstructionStepProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const InstructionSteps: React.FC<InstructionStepsProps> & {
  Step: React.FC<InstructionStepProps>;
} = ({ children, className = '' }) => {
  return (
    <div className={`email-sent-card__steps ${className}`}>
      {children}
    </div>
  );
};

const Step: React.FC<InstructionStepProps> = ({ icon, children, className = '' }) => {
  return (
    <div className={`email-sent-card__step ${className}`}>
      <div className="email-sent-card__step-icon">
        {icon}
      </div>
      <div className="email-sent-card__step-text">
        {children}
      </div>
    </div>
  );
};

InstructionSteps.Step = Step;

export default InstructionSteps;
